export default class Review {
    construct () {
        this.id = null
        this.reviewed_by = null
        this.project_id = null
        this.name = ""
        this.reviewed_on = Date()
    }
}